import Head from 'next/head';
import { __t } from 'common/i18n';

export const SITE_URL = 'https://filmnet.ir';
export const DEFAULT_SITE_DESCRIPTION = 'در فیلم‌نت جدیدترین فیلم‌ها و سریال‌ها را به صورت آنلاین تماشا کنید؛ دانلود اپلیکیشن فیلمنت و تماشا روی تلویزیون، لپ‌تاپ، موبایل یا تبلت.';

type SeoProps = {
  title: string;
  description?: string;
  path?: string;
  robots?: 'index, follow' | 'noindex, follow' | 'noindex, nofollow';
  image?: string;
  type?: 'website' | 'article' | 'video.movie' | 'video.tv_show' | 'profile';
};

export function absoluteUrl(path = '/') {
  if (path.startsWith('http')) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export default function Seo({
  title,
  description = DEFAULT_SITE_DESCRIPTION,
  path,
  robots,
  image,
  type = 'website',
}: SeoProps) {
  const canonical = path ? absoluteUrl(path) : undefined;
  const imageUrl = image ? absoluteUrl(image) : undefined;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} key="description" />
      {robots && <meta name="robots" content={robots} key="robots" />}
      {canonical && <link rel="canonical" href={canonical} key="canonical" />}

      <meta property="og:type" content={type} key="og:type" />
      <meta property="og:locale" content="fa_IR" key="og:locale" />
      <meta property="og:site_name" content={__t('static_siteName')} key="og:site_name" />
      <meta property="og:title" content={title} key="og:title" />
      <meta property="og:description" content={description} key="og:description" />
      {canonical && <meta property="og:url" content={canonical} key="og:url" />}
      {imageUrl && <meta property="og:image" content={imageUrl} key="og:image" />}

      <meta name="twitter:card" content={imageUrl ? 'summary_large_image' : 'summary'} key="twitter:card" />
      <meta name="twitter:title" content={title} key="twitter:title" />
      <meta name="twitter:description" content={description} key="twitter:description" />
      {imageUrl && <meta name="twitter:image" content={imageUrl} key="twitter:image" />}

      <meta name="DC.Language" content="fa" key="DC.Language" />
      <meta name="DC.Title" content={title} key="DC.Title" />
      <meta name="DC.Description" content={description} key="DC.Description" />
      {canonical && <meta name="DC.Identifier" content={canonical} key="DC.Identifier" />}
    </Head>
  );
}
